import { render, staticRenderFns } from "./AdminRequestsPayments.vue?vue&type=template&id=bf5d4598&scoped=true"
import script from "./AdminRequestsPayments.vue?vue&type=script&lang=js"
export * from "./AdminRequestsPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5d4598",
  null
  
)

export default component.exports